const o = "로딩 중", a = {
  loading: o
};
export {
  a as default,
  o as loading
};
